import React, { useState, useContext } from 'react';
import { navigate } from '@reach/router';

import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import TextField from '@material-ui/core/TextField';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import Typography from '@material-ui/core/Typography';

import { timestamp } from '../../app/data/validate';
import Copyright from '../Copyright';
import AuthContext from '../../services/firebase/AuthContext';
import FireDataContext from '../../services/firebase/FireDataContext';
import LoggingContext from '../../services/logging/LoggingContext';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const SignUpReferrerPage = () => {
  const errata = useContext(LoggingContext);
  const classes = useStyles();

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [pwd, setPwd] = useState('');

  const [error, setError] = useState('');
  const [waiting, setWaiting] = useState(false);

  const { signup } = useContext(AuthContext);
  const db = useContext(FireDataContext);

  const ready = () => {
    return [email, pwd, firstName, lastName, phone].every(Boolean);
    // && checkEmailAddress(email)
  }

  const handleError = ({ error, component }) => {
    setError(error);

    errata.log({
      component, 
      user: {
        uid: email,
        name: `${firstName} ${lastName} ${phone}`
      },
      error
    });
  }

  const handleSubmit = () => {
    try {
      const credentials = {
        email,
        password: pwd
      }

      signup(credentials)
        .then(({ user }) => {
          (async () => {
            // put newly signed up users into the temporary 0000 organisation until they choose / create their real one
            // it's easier to do this because once they're logged in they can have more db access
            // and therefore we can do db queries to find 
            const payload = {
              name: `${firstName} ${lastName}`,
              roles: ['customer'],
              organization: '0000',
              email: credentials.email,
              phone: phone,
              uid: user.uid,
              ts: timestamp(),
              verified: false
            }
            await db.update({
              path: `users/${user.uid}`,
              payload
            });

            await db.update({
              path: `organizations/0000/members/${user.uid}`,
              payload: {
                email: payload.email,
                ts: payload.ts
              }
            });

            await user.sendEmailVerification({
              url: 'https://ti-coop.web.app/signin'
            });
          })();

          navigate("/");
        })
        .catch(error => {
          handleError({component: 'SignUpReferrerPage.b1bd6eac38e3', error});
        });
    }
    catch (error) {
      handleError({component: 'SignUpReferrerPage.d8be1dabe1eb', error});

    }
    finally {
      setWaiting(false);
    }
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h6">The Intermediary Cooperative</Typography>
        <Avatar className={classes.avatar}>
          <PersonAddIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Referrer Sign up
        </Typography>
        <div className={classes.form}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                // value={firstName}
                onChange={({ target: { value } }) => setFirstName(value)}
                autoComplete="fname"
                name="firstName"
                variant="outlined"
                required
                fullWidth
                id="firstName"
                label="First Name"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                value={lastName}
                onChange={({ target: { value } }) => setLastName(value)}
                variant="outlined"
                required
                fullWidth
                id="lastName"
                label="Last Name"
                name="lastName"
                autoComplete="lname"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                value={email}
                onChange={({ target: { value } }) => setEmail(value)}
                variant="outlined"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                value={phone}
                onChange={({ target: { value } }) => setPhone(value)}
                variant="outlined"
                required
                fullWidth
                id="phone"
                label="Phone Number"
                name="phone"
                autoComplete="tel-local"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                value={pwd}
                onChange={({ target: { value } }) => setPwd(value)}
                variant="outlined"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
              />
            </Grid>
          </Grid>
          {
            error && <Alert variant="filled" severity="error" onClose={() => setError(undefined)} style={{ marginTop: '1rem', marginBottom: '0.5rem' }}><AlertTitle>Sign Up Problem</AlertTitle>{error.message}</Alert>
          }
          {
            !error &&
            <Button
              onClick={handleSubmit}
              disabled={waiting || !ready()}
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >Sign Up
            </Button>
          }
          <Grid container justify="flex-end">
            <Grid item>
              <Link href="/signin" variant="body2">
                Already have an account? Sign in
              </Link>
            </Grid>
          </Grid>
        </div>
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container>
  );

}

const SignUpReferrerPagePath = 'signup/referrer';

export {
  SignUpReferrerPagePath
}

export default SignUpReferrerPage;